import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import icon from 'flarum/common/helpers/icon';

export default class ReplyGroup extends Component {
  oninit(vnode) {
    this.attrs = vnode.attrs || {};
    const near = Number(typeof m !== 'undefined' && m.route ? m.route.param('near') : 0);
    const replies = Array.isArray(this.attrs.replies) ? this.attrs.replies : [];

    this.expanded = replies.some((reply) => Number(reply && reply.attrs && reply.attrs['data-number']) === near);
  }

  toggle(event) {
    event.preventDefault();
    this.expanded = !this.expanded;
  }

  view() {
    const replies = Array.isArray(this.attrs.replies) ? this.attrs.replies : [];

    if (!replies.length) return this.attrs.root;

    const label = this.expanded
      ? app.translator.trans('space-pocket-posts.forum.reply_group.collapse')
      : app.translator.trans('space-pocket-posts.forum.reply_group.expand', { count: replies.length });
    const repliesId = this.attrs.rootId ? `space-pocket-replies-${this.attrs.rootId}` : undefined;
    const rootId = String(this.attrs.rootId || 'root');

    const items = [
      this.attrs.root,
      <div key={`space-pocket-reply-toggle-${rootId}`} className="PostStream-item SpacePocketPosts-replyToggle">
        <button
          type="button"
          className="Button Button--flat"
          aria-expanded={this.expanded ? 'true' : 'false'}
          aria-controls={repliesId}
          onclick={(event) => this.toggle(event)}
        >
          {icon(this.expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down')}
          <span>{label}</span>
        </button>
      </div>,
    ];

    if (this.expanded) {
      items.push(
        <div key={`space-pocket-reply-items-${rootId}`} id={repliesId} className="SpacePocketPosts-replyItems">
          {replies}
        </div>
      );
    }

    return items;
  }
}
